export const appVersion = 1674997450;
